import { getModule } from './registry';
import { scriptLoad, versionLoad } from './utils/loaders';
import { setHash } from './utils/versions';

/**
 * Resolves the given module id by looking in the registry or by requesting it
 * in a external resource
 * @param {String} id Module Id
 * @return {Promise} Resolves the reference to the module in the registry
 */
export default function require(id) {
  const module = getModule(id);

  if (__DEV__) {
    // This is useful when testing in dev, so i'm going to leave the console.log
    // eslint-disable-next-line no-console,no-inline-comments
    console.log('Requiring module:', id); // NOSONAR
  }

  // Resolve if the module does not exists
  if (typeof module === 'undefined') {
    if (__DEV__) {
      // This is useful when testing in dev, so i'm going to leave the console.log
      // eslint-disable-next-line no-console,no-inline-comments
      console.log('Load version for:', id);// NOSONAR
    }

    // @TODO Support multiple version/files from the same library
    return versionLoad(id).
      then(versions => {
        setHash(id, versions.latest);
        return scriptLoad(id, versions.latest, versions.isExp);
      }).
      then(() => getModule(id)).
      catch(error => {
        throw new Error(
          `Error loading Script ${id}. Version not found. ${error}`
        );
      });
  }

  return Promise.resolve(module);
}
